export default "__VITE_ASSET__e61bd8b7__"